import React from 'react';
import { X } from 'lucide-react';

export default function VehicleFormOptions({ options, onChange }) {
  const addOption = () => {
    const option = prompt('Entrez une option/équipement:');
    if (option) onChange([...options, option]);
  };

  const removeOption = (index) => {
    onChange(options.filter((_, i) => i !== index));
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">Équipements / Options</label>
      <div className="flex flex-wrap gap-2 mb-2">
        {options.map((opt, index) => (
          <span key={`opt-${index}`} className="bg-gray-100 px-3 py-1 rounded-full text-sm flex items-center gap-2">
            {opt}
            <button type="button" onClick={() => removeOption(index)} className="text-gray-500 hover:text-red-500">
              <X size={14} />
            </button>
          </span>
        ))}
      </div>
      <button type="button" onClick={addOption} className="text-[#DC2626] text-sm hover:underline">
        + Ajouter une option
      </button>
    </div>
  );
}
